import { getAppTransaction,getAppStore,getDataByIndexCursor } from '@/indexedDB/indexedDBUtil.js';
import {formatTimeByDate} from '@/utils/date.js';
//保存日志
export function saveLog(logObj){
    return new Promise((resolve,reject)=>{
        getAppTransaction(['log']).then(transaction=>{
            const logStore=transaction.objectStore('log');
            let {userId,actionType,content}=logObj;
            let now=new Date();
            let timestamp=now.getTime();
            logStore.put({
                uniqKey:userId+'_'+timestamp,
                time:formatTimeByDate(now),
                timestamp,actionType,content,userId,
            });
            resolve(true);
        }).catch(err=>{
            reject(err);
        });
    });
}
export function getAllLog(userId){
    return new Promise((resolve,reject)=>{
        getAppStore('log','readonly').then(async store=>{
            getDataByIndexCursor(store,'userIndex',IDBKeyRange.only([userId])).then(list=>{
                resolve(list);
            }).catch(err=>{
                reject(err);
            });
        }).catch(err=>{
            reject(err);
        });
    });
}